import {
  DatagridBody as RaDatagridBody,
  DatagridBodyProps as RaDatagridBodyProps,
} from 'react-admin';

export const DatagridBody = RaDatagridBody;

export type DatagridBodyProps = RaDatagridBodyProps;
